import {OpPeriod} from '../../enums/operating-plan/op-period';


export class OpPeriodFactory {
  /**
   *
   * @param opPeriod
   */
  public static fromObject(opPeriod: any): OpPeriod {
    return new class implements OpPeriod {
      color: string = opPeriod.color;
      end: string = opPeriod.end;
      id: number = opPeriod.id;
      name: string = opPeriod.name;
      shortName: string = opPeriod.short_name;
      start: string = opPeriod.start;
    };
  }

  /**
   *
   * @param opPeriods
   */
  public static fromArray(opPeriods: OpPeriod[]): OpPeriod[] {
    return opPeriods.map(_opPeriod => OpPeriodFactory.fromObject(_opPeriod));
  }
}
